import { SaleItemDto } from "@/types/sale";
import { apiUrl } from "@/utils/url";
import { HttpClient } from "../HttpClient";
import { ISaleItemsService } from "./ISaleItemsService";

export class SaleItemsService implements ISaleItemsService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: apiUrl,
    });
  }

  async createSaleItem(saleItem: SaleItemDto): Promise<number> {
    const response = await this.httpClient.post<number>(
      "/sale-items",
      saleItem,
      {},
      true,
    );
    return response;
  }
}
